import React from "react";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const LANGS = [
  { code: "fr", label: "FR", name: "Français" },
  { code: "en", label: "EN", name: "English" },
  { code: "es", label: "ES", name: "Español" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const { user } = useAuth();

  const change = async (lng) => {
    if (i18n.language === lng) return;
    i18n.changeLanguage(lng);
    localStorage.setItem("elvarify-lang", lng);
    if (user) {
      try { await api.patch("/settings/ai-style", { language: lng }); } catch {}
    }
  };

  return (
    <div className="flex items-center gap-0.5 rounded-full border border-border bg-card p-0.5" data-testid="language-switcher">
      {LANGS.map((l) => (
        <button key={l.code} onClick={() => change(l.code)} title={l.name} data-testid={`lang-${l.code}`}
          className={`px-2.5 py-1 rounded-full text-[10px] font-bold transition-colors ${
            i18n.language === l.code ? "bg-electric text-white" : "text-muted-foreground hover:text-foreground"}`}>
          {l.label}
        </button>
      ))}
    </div>
  );
}
